type Condition<T = React.ReactNode> = [boolean, T];

interface IfElseChainProps {
  conditions: Condition[];
}
export const IfElseChain: React.FC<IfElseChainProps> = ({ conditions }) => {
  const matchedCondition = conditions.find(([condition]) => condition);
  return matchedCondition ? matchedCondition[1] : null;
};
